module.exports = __webpack_public_path__ + "static/media/armadillo-booking-6.84e4e062.png";